'use client';

import { cn } from '@/lib/tailwind';
import { useConsent } from './ConsentProvider';

type Props = {
    className?: string;
    children?: string;
};

export function CookieSettingsLink({ className, children = 'Cookie-Einstellungen' }: Props) {
    const { openSettings } = useConsent();

    return (
        <button
            type="button"
            onClick={openSettings}
            className={cn('cursor-pointer underline underline-offset-4 transition-opacity hover:opacity-70', className)}
        >
            {children}
        </button>
    );
}
